import { Box, Button, InputAdornment, Select, TextField, Typography, BaseTextFieldProps, MenuItem, CircularProgress } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { AmyPorterfield, clientPointWhite, dolbyWhite, foundrWhite, keapWhite, LogoDarkMode, susieMoore, ryanFenn, teachableWhite } from '../assets/images'
import { ArrowForward, ChevronLeft } from '@mui/icons-material';
import 'react-international-phone/style.css';
import { CountryIso2, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from 'react-international-phone';
import AuthService from '../services/auth.service'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CardComponent } from "@chargebee/chargebee-js-react-wrapper";
import chargebeeService from '../services/chargebee.service'
import { toast } from 'react-toastify'
import theme from '../theme'
import { decodeIdToken, decodeMetadataToken } from '../utils/token.utils';
import { LeadsquaredService } from '../services/leadsquared/leadsquared.service';
import { PLAN_NAMES } from '../constants/planNames';



export interface MUIPhoneProps extends BaseTextFieldProps {
    value: string;
    onChange: (phone: string) => void;
}

export const MuiPhone: React.FC<MUIPhoneProps> = ({
    value,
    onChange,
    ...restProps
}) => {
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: 'us',
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone);
            },
            disableCountryGuess: true,
            forceDialCode: true,
        });

    return (
        <TextField
            variant="outlined"
            label="Phone number"
            color="primary"
            placeholder="Phone number"
            value={inputValue}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    bgcolor: "#1B2024",
                    color: "#fff",
                    transition: "border-color 0.2s",
                    "& fieldset": {
                        borderColor: "#494D50",
                    },
                    "&:hover fieldset": {
                        borderColor: "#6066E9",
                    },
                    "&.Mui-focused fieldset": {
                        borderColor: "#6066E9",
                    },
                },
                "& .MuiInputLabel-root": {
                    color: "#B0B0B0",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                    color: "#6066E9",
                },
                "& .MuiOutlinedInput-input": {
                    padding: "14px 16px",
                    background: "transparent",
                    borderRadius: "8px",
                },
                "& input": {
                    color: "#fff",
                    "&::placeholder": {
                        color: "#B0B0B0",
                        fontSize: "16px",
                        opacity: 0.8,
                    },
                },
            }}

            slotProps={{
                input: {
                    startAdornment: <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',
                                    width: '360px',
                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{
                                width: 'max-content',
                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country.iso2}
                            onChange={(e) => setCountry(e.target.value as CountryIso2)}
                            disabled={restProps.disabled}
                            renderValue={(value) => (
                                <FlagImage iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c);
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </InputAdornment>
                },
            }}
            {...restProps}
        />
    );
};
const SSOSignup = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [showPromoField, setShowPromoField] = useState(false);

    const planId = searchParams.get("planId");
    const cleanPlanId = planId ? planId.replace(/-\d+$/, "") : undefined;

    // Add initialization functions similar to Signup component
    const initializeBillingPeriodFromUrl = () => {
        if (cleanPlanId) {
            return cleanPlanId.includes("Yearly");
        }
        return true; // Default to yearly
    };

    const initializeAttendeeLimitFromUrl = () => {
        if (planId) {
            const match = planId.match(/-(\d+)$/);
            if (match) {
                const limit = parseInt(match[1]);
                // Return the limit if it's valid, we'll validate against attendeeValues later
                return limit;
            }
        }
        return 250; // Default value that should work for most plans
    };

    const [attendeeValues, setAttendeeValues] = useState([
        50, 250, 500, 1000, 2000,
    ]);
    const [attendeeLimit, setAttendeeLimit] = useState(initializeAttendeeLimitFromUrl());
    const [isYearly, setIsYearly] = useState(initializeBillingPeriodFromUrl());
    const [isTrial, setIsTrial] = useState(false);
    const cardRef = useRef<any>(null);
    const [isCardValid, setIsCardValid] = useState(false);
    const [cardError, setCardError] = useState<string | null>(null);
    const [cardToken, setCardToken] = useState<string | null>(null);
    const [promoCode, setPromoCode] = useState("");
    const [promoError, setPromoError] = useState("");
    const [appliedPromo, setAppliedPromo] = useState<any>(null);
    const [planDetails, setPlanDetails] = useState<any>(null);
    const [monthlyPlanDetails, setMonthlyPlanDetails] = useState<any>(null);
    const [yearlyPlanDetails, setYearlyPlanDetails] = useState<any>(null);
    const [isLoadingPlan, setIsLoadingPlan] = useState(false);
    const [initialPlanId, setInitialPlanId] = useState<string | null>(null);

    // Set initial plan ID when component mounts
    useEffect(() => {
        if (planId && !initialPlanId) {
            setInitialPlanId(planId);
        }
    }, [planId, initialPlanId]);

    const testimonials = [
        {
            name: "Amy Porterfield",
            role: "Entrepreneur & Online Marketing Educator",
            text: "I personally use EasyWebinar and they are the best. I moved from using other platforms and nothing compares to their reliability and customer support!",
            avatar: "AP",
            image: AmyPorterfield,
        },
        {
            name: "Susie Moore",
            role: "Author/Lifecoach",
            text: "The name is completely self-explanatory. Easiest integrations, best customer service, and EASY to use.",
            avatar: "SM",
            image: susieMoore,
        },
        {
            name: "Ryan Fenn",
            role: "CEO and Founder of Chirp",
            text: "We made 2 million dollars using EasyWebinar. We created one webinar, one time, and ran it for 3 years.",
            avatar: "RF",
            image: ryanFenn,
        },
    ];

    const [formData, setFormData] = useState({
        fullName: '',
        email: ''
    });
    const [formErrors, setFormErrors] = useState({
        fullName: '',
        email: '',
        phone: ''
    });
    const [phone, setPhone] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState<'form' | 'payment'>('payment');

    const [isChargebeeReady, setIsChargebeeReady] = useState(false);









    useEffect(() => {
        const fetchPlanDetails = async () => {
            if (!initialPlanId) return;

            const cleanInitialPlanId = initialPlanId.replace(/-\d+$/, '');
            setIsLoadingPlan(true);
            try {
                // Fetch both monthly and yearly plan details at once using clean plan IDs without numbers
                const basePlanId = cleanInitialPlanId.replace(/(Monthly|Yearly)/g, "");
                const monthlyPlanId = `${basePlanId}Monthly`;
                const yearlyPlanId = `${basePlanId}Yearly`;

                // Fetch both plans in parallel
                const [monthlyResponse, yearlyResponse] = await Promise.all([
                    chargebeeService.getPlanById(monthlyPlanId),
                    chargebeeService.getPlanById(yearlyPlanId)
                ]);

                // Store both plan details
                setPlanDetails(isYearly ? yearlyResponse.data : monthlyResponse.data);
                setMonthlyPlanDetails(isYearly ? monthlyResponse.data : yearlyResponse.data);

            } catch (error) {
                console.error('Failed to fetch plan details:', error);
                // Fallback: try to fetch just the current plan
                try {
                    const response = await chargebeeService.getPlanById(cleanInitialPlanId);
                    setPlanDetails(response.data);
                } catch (fallbackError) {
                    console.error('Failed to fetch fallback plan details:', fallbackError);
                }
            } finally {
                setIsLoadingPlan(false);
            }
        };
        fetchPlanDetails();
    }, [initialPlanId]);

    useEffect(() => {
        const checkChargebee = () => {
            if (window.Chargebee) {
                setIsChargebeeReady(true);
            } else {
                setTimeout(checkChargebee, 100);
            }
        };

        checkChargebee();
    }, []);

    useEffect(() => {
        const decodedToken = decodeIdToken();
        if (decodedToken) {
            setFormData({
                fullName: decodedToken.name ||
                    `${decodedToken.given_name || ''} ${decodedToken.family_name || ''}`.trim(),
                email: decodedToken.email || ''
            });

            // Auto-populate phone number if it exists in the token
            if (decodedToken.phone_number) {
                setPhone(decodedToken.phone_number);
            }
        }
    }, []);



    useEffect(() => {
        const checkChargebee = () => {
            if (window.Chargebee) {
                setIsChargebeeReady(true);
            } else {
                setTimeout(checkChargebee, 100);
            }
        };

        checkChargebee();
    }, []);

    // Update attendee values when plan details are loaded
    useEffect(() => {
        const planToCheck = planDetails || yearlyPlanDetails || monthlyPlanDetails;
        if (planToCheck && planToCheck.tiers) {
            // Get tiers with ending_unit (standard tiers)
            const standardTiers = planToCheck.tiers.filter(
                (tier: any) =>
                    tier.ending_unit !== null && tier.ending_unit !== undefined
            );
            const tierValues = standardTiers
                .map((tier: any) => tier.ending_unit)
                .sort((a: number, b: number) => a - b);

            // Check if there are unlimited tiers (no ending_unit)
            const unlimitedTiers = planToCheck.tiers.filter(
                (tier: any) =>
                    tier.ending_unit === null || tier.ending_unit === undefined
            );

            let newAttendeeValues = [...tierValues];

            // If there are unlimited tiers and attendeeLimit is higher than max standard tier, use it
            if (unlimitedTiers.length > 0 && tierValues.length > 0) {
                const maxStandardTier = Math.max(...tierValues);
                if (
                    attendeeLimit > maxStandardTier &&
                    !tierValues.includes(attendeeLimit)
                ) {
                    newAttendeeValues.push(attendeeLimit);
                    newAttendeeValues.sort((a: number, b: number) => a - b);
                }
            } else if (tierValues.length > 0) {
                // If no unlimited tiers, but attendeeLimit is higher than max, still include it as custom
                const maxTierValue = Math.max(...tierValues);
                if (
                    attendeeLimit > maxTierValue &&
                    !tierValues.includes(attendeeLimit)
                ) {
                    newAttendeeValues.push(attendeeLimit);
                    newAttendeeValues.sort((a: number, b: number) => a - b);
                }
            }

            setAttendeeValues(newAttendeeValues);
        }
    }, [planDetails, yearlyPlanDetails, monthlyPlanDetails, attendeeLimit]);

    // Ensure attendeeLimit is valid when attendeeValues change
    useEffect(() => {
        if (attendeeValues.length > 0) {
            if (!attendeeValues.includes(attendeeLimit)) {
                const maxValue = Math.max(...attendeeValues);
                const minValue = Math.min(...attendeeValues);

                // Only adjust if attendeeLimit is completely outside the valid range
                if (attendeeLimit < minValue) {
                    const closest = attendeeValues.reduce((prev: number, curr: number) =>
                        Math.abs(curr - attendeeLimit) < Math.abs(prev - attendeeLimit)
                            ? curr
                            : prev
                    );
                    console.log(
                        `Attendee limit ${attendeeLimit} is below minimum available value ${minValue}, using closest match: ${closest}`
                    );
                    setAttendeeLimit(closest);
                    updatePlanInUrl(isYearly, closest);
                } else {
                    console.log(
                        `Preserving attendee limit ${attendeeLimit} as it's within or above valid range (${minValue}-${maxValue})`
                    );
                }
            }
        }
    }, [attendeeValues, attendeeLimit, isYearly]);

    // Set default planId if not present
    useEffect(() => {
        if (!planId) {
            setSearchParams((prev) => {
                prev.set("planId", "All-In-One-USD-Yearly-200");
                return prev;
            }, { replace: true });
        }

        // Check if this is a free trial plan
        setIsTrial(planId === PLAN_NAMES.FREE_TRIAL);
    }, [planId, setSearchParams]);

    const getPlanPrice = () => {
        if (!planDetails || !attendeeLimit) {
            return { price: 0, discountedPrice: 0 };
        }

        const tier = planDetails.tiers.find((tier: any) => {
            if (!tier.ending_unit) {
                return attendeeLimit >= tier.starting_unit;
            }
            return (
                attendeeLimit >= tier.starting_unit &&
                attendeeLimit <= tier.ending_unit
            );
        });

        if (!tier) {
            return { price: 0, discountedPrice: 0 };
        }

        const basePrice = Math.round(tier.price / 100);
        // Always return the original price, promo discount will only be applied in summary
        return { price: basePrice, discountedPrice: basePrice };
    };



    // Update URL when billing period or attendee limit changes
    const updatePlanInUrl = (newIsYearly: boolean, newAttendeeLimit: number) => {
        if (!cleanPlanId) return;

        const baseCleanPlanId = cleanPlanId.replace(/(Monthly|Yearly)/g, "");
        const period = newIsYearly ? "Yearly" : "Monthly";
        const newPlanId = `${baseCleanPlanId}${period}-${newAttendeeLimit}`;

        setSearchParams((prev) => {
            prev.set("planId", newPlanId);
            return prev;
        }, { replace: true });
    };

    const handleBillingPeriodChange = async (newIsYearly: boolean) => {
        // If the user clicks on the already selected option, do nothing
        if (isYearly === newIsYearly) {
            return;
        }

        setIsYearly(newIsYearly);
        updatePlanInUrl(newIsYearly, attendeeLimit);

        // Swap the plan details without making API calls
        if (planDetails && monthlyPlanDetails) {
            if (newIsYearly) {
                // Switching to yearly: set planDetails to yearly, monthlyPlanDetails to monthly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains yearly data
                setMonthlyPlanDetails(planDetails); // planDetails contains monthly data
            } else {
                // Switching to monthly: set planDetails to monthly, monthlyPlanDetails to yearly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains monthly data
                setMonthlyPlanDetails(planDetails); // planDetails contains yearly data
            }
        }

        // Re-validate coupon if one is applied
        if (appliedPromo && promoCode.trim()) {
            try {
                const planId = searchParams.get('planId');
                const response = await chargebeeService.validateCoupon(
                    promoCode,
                    planId ? planId.replace(/-\d+$/, '') : undefined
                );

                if (response.data.valid) {
                    const { coupon } = response.data;
                    setAppliedPromo({
                        code: coupon.id,
                        discount: coupon.discountPercentage || coupon.discountAmount,
                        type: coupon.discountType
                    });
                    setPromoError('');
                } else {
                    setAppliedPromo(null);
                    setPromoCode('');
                }
            } catch (error) {
                console.error('Error re-validating coupon:', error);
                setPromoError('Failed to validate coupon for new plan');
                setAppliedPromo(null);
            }
        }
    };



    const validatePhone = (phoneNumber: string) => {
        const digitsOnly = phoneNumber.replace(/\D/g, '');
        return digitsOnly.length >= 10 && digitsOnly.length <= 15;
    };

    const validateForm = () => {
        const errors = {
            fullName: '',
            email: '',
            phone: ''
        };
        let isValid = true;

        // Check required fields
        if (!formData.fullName.trim()) {
            errors.fullName = 'Full name is required';
            isValid = false;
        }

        if (!formData.email.trim()) {
            errors.email = 'Email is required';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Please enter a valid email';
            isValid = false;
        }

        if (!phone.trim()) {
            errors.phone = 'Phone number is required';
            isValid = false;
        } else if (!validatePhone(phone)) {
            errors.phone = 'Please enter a valid phone number';
            isValid = false;
        }

        setFormErrors(errors);
        return isValid;
    };




    const handlePhoneChange = (value: string) => {
        setPhone(value);
        // Clear phone error when user starts typing
        setFormErrors(prev => ({
            ...prev,
            phone: ''
        }));
    };

    const updateLeadsquaredActivity = async (email: string | undefined, planId: string | undefined, phoneNumber: string | undefined) => {
        if (!email || !planId) {
            console.error('Email or planId is missing in LS');
            return;
        }

        setIsLoading(true);
        try {
            const LsData = await LeadsquaredService.getLeadsByEmail(email as string);
            const LsId = (LsData as any).ProspectID;
            if (planId === "free-trial-plan") {
                await LeadsquaredService.joinActivity({
                    id: LsId,
                    activityEvent: 205,
                    activityValue: "Free Plan",
                    activityNote: "SSO Authentication"
                });
            } else {
                await LeadsquaredService.joinActivity({
                    id: LsId,
                    activityEvent: 205,
                    activityValue: planId,
                    activityNote: "SSO Authentication"
                });
                LeadsquaredService.joinActivity({
                    id: LsId,
                    activityEvent: 205,
                    activityValue: "Currently In Trial",
                    activityNote: "SSO Authentication"
                });
            }
            const leadData = {
                "leadId": LsId,
                "fields": [
                    { "Attribute": "mx_Plan_Name", "Value": planId },
                    { "Attribute": "mx_Status", "Value": "Active" },
                    { "Attribute": "Source", "Value": localStorage.getItem('utm_source') },
                    { "Attribute": "SourceMedium", "Value": localStorage.getItem('utm_medium') },
                    { "Attribute": "SourceCampaign", "Value": localStorage.getItem('utm_campaign') },
                    { "Attribute": "SourceContent", "Value": localStorage.getItem('utm_content') },
                    { "Attribute": "mx_Source_Term", "Value": localStorage.getItem('utm_term') },
                    { "Attribute": "gc_id", "Value": localStorage.getItem('gc_id') },
                    { "Attribute": "h_ga_id", "Value": localStorage.getItem('h_ga_id') },
                    { "Attribute": "h_keyword_id", "Value": localStorage.getItem('h_keyword_id') },
                    { "Attribute": "h_keyword", "Value": localStorage.getItem('h_keyword') },
                    { "Attribute": "h_placement", "Value": localStorage.getItem('h_placement') },
                    { "Attribute": "g_special_campaign", "Value": localStorage.getItem('g_special_campaign') },
                    ...(phoneNumber?.trim() ? [{ "Attribute": "Phone", "Value": phoneNumber }] : [])
                ]
            }
            LeadsquaredService.updateLsField(leadData);
        } catch (error) {
            console.error('Error in LS tags:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleNext = async () => {
        if (currentStep === 'form') {
            // First step: validate form and proceed to payment
            if (!validateForm()) {
                return;
            }

            // Simply proceed to payment step without making any API calls
            // Phone number will be updated during the payment process if needed
            setCurrentStep('payment');
            return;
        }
    };

    const validateCoupon = async () => {
        if (!promoCode.trim()) {
            setPromoError('Please enter a promo code');
            return;
        }

        try {
            const planId = searchParams.get('planId');
            const response = await chargebeeService.validateCoupon(
                promoCode,
                planId ? planId.replace(/-\d+$/, '') : undefined // Only pass planId if it exists
            );

            if (response.data.valid) {
                const { coupon } = response.data;
                setAppliedPromo({
                    code: coupon.id,
                    discount: coupon.discountPercentage || coupon.discountAmount,
                    type: coupon.discountType // 'percentage' or 'fixed_amount'
                });
                setPromoError('');
                setShowPromoField(false);
            } else {
                setPromoError(response.data.error || 'Invalid promo code');
                setAppliedPromo(null);
            }
        } catch (error) {
            console.error('Error validating coupon:', error);
            setPromoError('Failed to validate promo code');
            setAppliedPromo(null);
        }
    };

    const removePromoCode = () => {
        setAppliedPromo(null);
        setPromoCode("");
        setPromoError("");
        setShowPromoField(true);
    };

    const calculateDynamicPricing = () => {
        if (isLoadingPlan || !planDetails) {
            return {
                currentPrice: "$00.00",
                alternativePrice: "$00.00",
                savings: "$00.00",
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? "year" : "month",
                alternativePeriod: isYearly ? "month" : "year",
            };
        }

        const quantity = planId
            ? parseInt(planId.match(/-(\d+)$/)?.[1] || "0")
            : 0;

        if (planId === PLAN_NAMES.FREE_TRIAL) {
            return {
                currentPrice: "$00.00",
                alternativePrice: "$00.00",
                savings: "$00.00",
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? "year" : "month",
                alternativePeriod: isYearly ? "month" : "year",
            };
        }

        // Find the current plan tier
        const currentTier = planDetails?.tiers.find((tier: any) => {
            if (!tier.ending_unit) {
                return quantity >= tier.starting_unit;
            }
            return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
        });

        if (!currentTier) {
            return {
                currentPrice: "$00.00",
                alternativePrice: "$00.00",
                savings: "$00.00",
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? "year" : "month",
                alternativePeriod: isYearly ? "month" : "year",
            };
        }

        // Get current plan price
        const currentPrice = currentTier.price / 100; // Convert cents to dollars
        let discountedCurrentPrice = currentPrice;

        // Apply discount if promo code is applied
        if (appliedPromo) {
            if (appliedPromo.type === "percentage") {
                discountedCurrentPrice =
                    currentPrice * (1 - appliedPromo.discount / 100);
            } else if (appliedPromo.type === "fixed_amount") {
                discountedCurrentPrice = Math.max(
                    0,
                    currentPrice - appliedPromo.discount / 100
                );
            }
        }

        // Calculate alternative pricing
        let alternativePrice = 0;
        let alternativeTier = null;

        if (isYearly) {
            // If yearly is selected, calculate monthly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return (
                        quantity >= tier.starting_unit && quantity <= tier.ending_unit
                    );
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === "percentage") {
                            alternativePrice =
                                alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === "fixed_amount") {
                            alternativePrice = Math.max(
                                0,
                                alternativePrice - appliedPromo.discount / 100
                            );
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate monthly price as 1/12 of yearly price
                    alternativePrice = currentPrice;
                }
            } else {
                // Fallback: estimate monthly price as 1/12 of yearly price
                alternativePrice = currentPrice;
            }
        } else {
            // If monthly is selected, calculate yearly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return (
                        quantity >= tier.starting_unit && quantity <= tier.ending_unit
                    );
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === "percentage") {
                            alternativePrice =
                                alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === "fixed_amount") {
                            alternativePrice = Math.max(
                                0,
                                alternativePrice - appliedPromo.discount / 100
                            );
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    alternativePrice = currentPrice * 12;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                alternativePrice = currentPrice * 12;
            }
        }

        // Calculate static monthly and yearly prices
        let monthlyPrice = 0;
        let yearlyPrice = 0;

        // Calculate monthly price
        if (isYearly) {
            // If yearly is selected, use the monthly plan details
            if (monthlyPlanDetails) {
                const monthlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return (
                        quantity >= tier.starting_unit && quantity <= tier.ending_unit
                    );
                });

                if (monthlyTier) {
                    monthlyPrice = monthlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === "percentage") {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === "fixed_amount") {
                            monthlyPrice = Math.max(
                                0,
                                monthlyPrice - appliedPromo.discount / 100
                            );
                        }
                    }
                }
            }
        } else {
            // If monthly is selected, use the current plan details
            if (planDetails && planDetails.periodUnit === "month") {
                const monthlyTier = planDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return (
                        quantity >= tier.starting_unit && quantity <= tier.ending_unit
                    );
                });

                if (monthlyTier) {
                    monthlyPrice = monthlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === "percentage") {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === "fixed_amount") {
                            monthlyPrice = Math.max(
                                0,
                                monthlyPrice - appliedPromo.discount / 100
                            );
                        }
                    }
                }
            }
        }

        // Calculate yearly price (monthly equivalent)
        if (isYearly) {
            // If yearly is selected, use the current yearly price
            yearlyPrice = discountedCurrentPrice / 12;
        } else {
            // If monthly is selected, use the actual yearly price from alternative plan details
            if (monthlyPlanDetails && monthlyPlanDetails.periodUnit === "year") {
                // Use the fetched yearly plan details
                const yearlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return (
                        quantity >= tier.starting_unit && quantity <= tier.ending_unit
                    );
                });

                if (yearlyTier) {
                    let yearlyPriceValue = yearlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === "percentage") {
                            yearlyPriceValue =
                                yearlyPriceValue * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === "fixed_amount") {
                            yearlyPriceValue = Math.max(
                                0,
                                yearlyPriceValue - appliedPromo.discount / 100
                            );
                        }
                    }
                    yearlyPrice = yearlyPriceValue / 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    yearlyPrice = discountedCurrentPrice;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                yearlyPrice = discountedCurrentPrice;
            }
        }

        // Calculate savings
        let savings = 0;
        let savingsPercentage = 0;

        if (isYearly) {
            // If yearly is selected, savings = monthly equivalent - yearly price
            // Use original prices for savings calculation
            const originalAlternativePrice = alternativePrice / (appliedPromo ? (1 - appliedPromo.discount / 100) : 1);
            const originalCurrentPrice = currentPrice;
            savings = Math.abs(originalAlternativePrice - originalCurrentPrice);

            // Add promo code discount to savings if applied
            if (appliedPromo) {
                if (appliedPromo.type === "percentage") {
                    savings += (originalCurrentPrice * appliedPromo.discount / 100);
                } else if (appliedPromo.type === "fixed_amount") {
                    savings += (appliedPromo.discount / 100);
                }
            }

            savingsPercentage =
                originalAlternativePrice > 0
                    ? Math.round((savings / originalAlternativePrice) * 100)
                    : 0;
        } else {
            // If monthly is selected, savings = (monthly price × 12) - actual yearly price
            // Use original prices for savings calculation
            const originalMonthlyPrice = monthlyPrice / (appliedPromo ? (1 - appliedPromo.discount / 100) : 1);
            const yearlyEquivalent = originalMonthlyPrice * 12;
            const actualYearlyPrice = monthlyPlanDetails
                ? (monthlyPlanDetails.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return (
                        quantity >= tier.starting_unit && quantity <= tier.ending_unit
                    );
                })?.price || 0) / 100
                : 0;

            savings = Math.abs(yearlyEquivalent - actualYearlyPrice);

            // Add promo code discount to savings if applied
            if (appliedPromo) {
                if (appliedPromo.type === "percentage") {
                    savings += (actualYearlyPrice * appliedPromo.discount / 100);
                } else if (appliedPromo.type === "fixed_amount") {
                    savings += (appliedPromo.discount / 100);
                }
            }

            savingsPercentage =
                actualYearlyPrice > 0
                    ? Math.round((savings / actualYearlyPrice) * 100)
                    : 0;
        }

        return {
            currentPrice: `$${Math.round(discountedCurrentPrice)}`,
            alternativePrice: `$${Math.round(alternativePrice)}`,
            savings: `$${Math.round(savings)}`,
            savingsPercentage,
            isYearlySelected: isYearly,
            currentPeriod: isYearly ? "year" : "month",
            alternativePeriod: isYearly ? "month" : "year",
            currentPriceValue: discountedCurrentPrice || 0,
            alternativePriceValue: alternativePrice || 0,
            monthlyPrice: `$${Math.round(monthlyPrice)}`,
            yearlyPrice: `$${Math.round(yearlyPrice)}`,
        };
    };

    const handleGetStarted = async () => {
        setIsLoading(true);
        try {

            // Check if card has any validation errors
            if (cardError) {
                toast.error('Please fix card validation errors before proceeding');
                setIsLoading(false);
                return;
            }

            const result = await cardRef.current.tokenize();

            if (result.error) {
                setCardError(result.error.message || 'Card tokenization failed');
                setIsLoading(false);
                return;
            }

            const cardTokenResult = result.token;
            setCardToken(cardTokenResult);
            setCardError(null);

            if (!cardTokenResult) {
                setCardError('Please enter valid card details');
                toast.error('Please enter valid card details');
                setIsLoading(false);
                return;
            }

            const metadata = decodeMetadataToken();
            const customerId = metadata?.companies?.[0]?.id || ''
            const basePlanId = planDetails?.id
            const cardToken = cardTokenResult
            const couponId = appliedPromo?.code
            const planUnits = parseInt(planId?.match(/-(\d+)$/)?.[1] || '1') || 1

            // First add payment source, then create subscription only if payment source is added successfully
            const cardResponse = await chargebeeService.addPaymentSource(customerId, cardToken);

            if (!cardResponse || cardResponse.error) {
                throw new Error('Failed to add payment source');
            }

            // Only create subscription after payment source is successfully added
            const subscriptionResponse = await chargebeeService.createSubscription(customerId, basePlanId, couponId, planUnits);

            // Track Google Ads conversion with final amount
            try {
                const priceData = getPlanPrice();
                const conversionValue = isTrial ? 0.0 : priceData.discountedPrice;

                // Check if gtag is available (Google Analytics/Ads script loaded)
                if (typeof window !== 'undefined' && (window as any).gtag) {
                    (window as any).gtag('event', 'conversion', {
                        'send_to': 'AW-1030214605/Q5VyCL-xrs4aEM2nn-sD',
                        'value': conversionValue,
                        'currency': 'USD'
                    });
                }
            } catch (conversionError) {
                // Log the error but don't block the flow
                console.error('Google Ads conversion tracking failed:', conversionError);
            }

            // Update Leadsquared activity
            await updateLeadsquaredActivity(formData.email, cleanPlanId, phone);

            await AuthService.refreshToken();
            toast.success('Subscription created successfully');

            // Clear planId from localStorage before navigation
            localStorage.removeItem('planId');

            // Use window.location.href for full page navigation instead of client-side routing, required for gtm tracking
            window.location.href = `/loading-dashboard?ew_email=${formData.email}&planId=${planId}&sso=true&phone=${encodeURIComponent(phone)}`;
        } catch (error: any) {
            console.error('Failed to start trial:', error);

            if (error.message === '409') {
                toast.error('You already have an active subscription. Cannot create duplicate subscription.');
                navigate('/logout');
                return;
            }

            if (error.name === 'INVALID_CARD') {
                setCardError('Please enter valid card details');
            } else {
                toast.error(error.message || 'An error occurred. Please try again.');
            }
            toast.error('Failed to start trial');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100vw",
                background: `
                        linear-gradient(180deg, #010007 26.92%, #AC8DFF 100%),
                        linear-gradient(180deg, #FFFFEF 0%, #FFF 100%)
                    `,
                color: "#1f2937",
                fontFamily: "Inter",
            }}
        >
            {/* Header */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: { xs: "16px 24px", sm: "24px 32px" },
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={LogoDarkMode}
                        alt="logo"
                        style={{ height: 24, cursor: 'pointer', maxWidth: '100%' }}
                        onClick={() => window.open('https://easywebinar.com/', '_blank')}
                    />
                </Box>
                <Button
                    variant="contained"
                    endIcon={<ArrowForward />}
                    size="small"
                    onClick={() => navigate("/logout")}
                    sx={{
                        bgcolor: "#6066E9",
                        color: "#fff",
                        borderRadius: "8px",
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": { bgcolor: "#4B4EB5" },
                    }}
                >
                    Logout
                </Button>
            </Box>

            {/* Step 1 - Form Collection */}
            {currentStep === 'form' && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: {
                            xs: "calc(100vh - 120px)",
                            sm: "calc(100vh - 100px)",
                            md: "calc(100vh - 80px)",
                        },
                        p: { xs: 1, sm: 2 },
                        pt: { xs: 1, sm: 2, md: 3 },
                    }}
                >
                    {/* Main container with border - responsive sizing */}
                    <Box
                        sx={{
                            width: { xs: "100%", sm: "90%", md: "1200px", lg: "1400px" },
                            maxWidth: { xs: "600px", md: "none" },
                            height: { xs: "auto", md: "650px", xl: "776px" },
                            border: "1.5px solid #494D50",
                            borderRadius: "18px",
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            bgcolor: "#141414",
                            boxShadow: "0 4px 32px 0 rgba(0,0,0,0.25)",
                            overflow: "hidden",
                        }}
                    >
                        {/* Left side - Form - responsive sizing */}
                        <Box
                            sx={{
                                width: { xs: "100%", sm: "100%", md: "583px", lg: "650px" },
                                bgcolor: "#141414",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: { xs: "18px", md: "18px 0 0 18px" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#ffffff",
                                    textAlign: "center",
                                    mb: 1,
                                    fontSize: { xs: "24px", sm: "28px", md: "32px" },
                                    fontWeight: 700,
                                }}
                            >
                                Create your free account
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#B0B0B0",
                                    textAlign: "center",
                                    mb: { xs: 3, md: 4 },
                                    fontSize: { xs: "13px", sm: "14px" },
                                }}
                            >
                                100% Free, 7-Day Trial
                            </Typography>

                            {/* Progress indicator */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    mb: { xs: 3, md: 4 },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 4,
                                        backgroundColor: "#6066E9",
                                        borderRadius: 1,
                                        mr: 1,
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 4,
                                        backgroundColor: "#232323",
                                        borderRadius: 1,
                                    }}
                                />
                            </Box>

                            {/* Form Fields */}
                            <Box component="form" onSubmit={(e) => { e.preventDefault(); handleNext(); }} width="100%">
                                <TextField
                                    fullWidth
                                    label="Full Name"
                                    name="fullName"
                                    value={formData.fullName}
                                    error={!!formErrors.fullName}
                                    helperText={formErrors.fullName}
                                    autoComplete="off"
                                    inputProps={{
                                        autoComplete: "off",
                                        autoFill: "off",
                                        readOnly: true
                                    }}
                                    sx={{
                                        mb: 3,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "8px",
                                            bgcolor: "#1B2024",
                                            color: "#fff",
                                            transition: "border-color 0.2s",
                                            "& fieldset": {
                                                borderColor: "#494D50",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#6066E9",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#6066E9",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            color: "#B0B0B0",
                                        },
                                        "& .MuiInputLabel-root.Mui-focused": {
                                            color: "#6066E9",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                            padding: "14px 16px",
                                        },
                                        "& input": {
                                            color: "#fff",
                                            "&::placeholder": {
                                                color: "#B0B0B0",
                                                opacity: 1,
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#f87171",
                                        },
                                    }}
                                />

                                <TextField
                                    fullWidth
                                    label="Email Address"
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    error={!!formErrors.email}
                                    helperText={formErrors.email}
                                    autoComplete="off"
                                    inputProps={{
                                        autoComplete: "off",
                                        autoFill: "off",
                                        readOnly: true
                                    }}
                                    sx={{
                                        mb: 3,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "8px",
                                            bgcolor: "#1B2024",
                                            color: "#fff",
                                            transition: "border-color 0.2s",
                                            "& fieldset": {
                                                borderColor: "#494D50",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#6066E9",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#6066E9",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            color: "#B0B0B0",
                                        },
                                        "& .MuiInputLabel-root.Mui-focused": {
                                            color: "#6066E9",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                            padding: "14px 16px",
                                        },
                                        "& input": {
                                            color: "#fff",
                                            "&::placeholder": {
                                                color: "#B0B0B0",
                                                opacity: 1,
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#f87171",
                                        },
                                    }}
                                />

                                <MuiPhone
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    error={!!formErrors.phone}
                                    helperText={formErrors.phone}
                                    fullWidth
                                    sx={{
                                        mb: 3,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "8px",
                                            bgcolor: "#1B2024",
                                            color: "#fff",
                                            transition: "border-color 0.2s",
                                            "& fieldset": {
                                                borderColor: "#494D50",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#6066E9",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#6066E9",
                                            },
                                            "& .MuiSvgIcon-root": {
                                                color: "#ffffff",
                                            },
                                        },
                                        "& .MuiInputLabel-root.Mui-focused": {
                                            color: "#6066E9",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                            padding: "14px 16px",
                                        },
                                        "& input": {
                                            color: "#fff",
                                            "&::placeholder": {
                                                color: "#B0B0B0",
                                                opacity: 1,
                                            },
                                            // Override autofill background
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px #1B2024 inset !important",
                                                WebkitTextFillColor: "#fff !important",
                                                transition: "background-color 5000s ease-in-out 0s",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px #1B2024 inset !important",
                                                WebkitTextFillColor: "#fff !important",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px #1B2024 inset !important",
                                                WebkitTextFillColor: "#fff !important",
                                            },
                                            "&:-webkit-autofill:active": {
                                                WebkitBoxShadow: "0 0 0 1000px #1B2024 inset !important",
                                                WebkitTextFillColor: "#fff !important",
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#f87171",
                                        },
                                    }}
                                />

                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={handleNext}
                                    disabled={!formData.fullName || !formData.email || !phone || isLoading}
                                    sx={{
                                        mb: 3,
                                        bgcolor: "#6066E9",
                                        color: "#fff",
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        fontSize: { xs: 15, sm: 17 },
                                        py: 1.3,
                                        textTransform: "none",
                                        boxShadow: "none",
                                        "&:hover": { bgcolor: "#4B4EB5" },
                                        "&:disabled": { bgcolor: "#6b7280", color: "#9ca3af" },
                                    }}
                                >
                                    {isLoading ? (
                                        <CircularProgress size={22} sx={{ color: "#fff" }} />
                                    ) : !formData.fullName || !formData.email || !phone ? (
                                        "Please enter full name, email and phone number"
                                    ) : (
                                        "Get started free"
                                    )}
                                </Button>

                                <Typography
                                    sx={{
                                        color: "#B0B0B0",
                                        textAlign: "center",
                                        fontSize: { xs: 10, sm: 11 },
                                        lineHeight: 1.5,
                                    }}
                                >
                                    By signing up, you agree to our{" "}
                                    <Box
                                        component="span"
                                        sx={{
                                            color: "#6066E9",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            "&:hover": { textDecoration: "underline" },
                                        }}
                                        onClick={() =>
                                            window.open(
                                                "https://easywebinar.com/terms-conditions/",
                                                "_blank"
                                            )
                                        }
                                    >
                                        Terms of Service
                                    </Box>{" "}
                                    and{" "}
                                    <Box
                                        component="span"
                                        sx={{
                                            color: "#6066E9",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            "&:hover": { textDecoration: "underline" },
                                        }}
                                        onClick={() =>
                                            window.open("https://easywebinar.com/privacy/", "_blank")
                                        }
                                    >
                                        Privacy Policy
                                    </Box>
                                    . You also agree to receive account-related emails from
                                    EasyWebinar, including tips and product updates.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Right side - Testimonials container - Hidden on small devices */}
                        <Box
                            sx={{
                                display: { xs: "none", md: "flex" },
                                flex: 1,
                                alignItems: "center",
                                justifyContent: "center",
                                p: 4,
                                bgcolor: "#000000",
                                borderRadius: "0 18px 18px 0",
                            }}
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: "600px",
                                    height: "auto",
                                    bgcolor: "#000000",
                                    borderRadius: 2,
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                }}
                            >
                                {/* Testimonials */}
                                {testimonials.map((testimonial, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: "100%",
                                            height: "auto",
                                            bgcolor: "#1a1a1a",
                                            border: "1px solid #333333",
                                            borderRadius: 2,
                                            p: 2,
                                            mb: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1.5,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 48,
                                                height: 48,
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                flexShrink: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                bgcolor: "#6066E9",
                                            }}
                                        >
                                            <img
                                                src={testimonial.image}
                                                alt={testimonial.name}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ flex: 1, overflow: "hidden" }}>
                                            <Typography
                                                sx={{
                                                    color: "#ffffff",
                                                    mb: 1,
                                                    fontSize: "14px",
                                                    lineHeight: 1.4,
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {testimonial.text}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    color: "#B0B0B0",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                <Box
                                                    component="span"
                                                    sx={{ fontWeight: 600, color: "#ffffff" }}
                                                >
                                                    {testimonial.name}
                                                </Box>{" "}
                                                ({testimonial.role})
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}

                                <Box sx={{ textAlign: "center", mt: 3 }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            mb: 2,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#ffffff",
                                                fontSize: "24px",
                                                fontWeight: 700,
                                                mr: 1,
                                            }}
                                        >
                                            4.4
                                        </Typography>
                                        <Box sx={{ color: "#fbbf24", mr: 1, fontSize: "16px" }}>
                                            ★★★★★
                                        </Box>
                                        <Typography sx={{ color: "#B0B0B0", fontSize: "14px" }}>
                                            on G2 reviews
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{ display: "flex", justifyContent: "center", gap: 3 }}
                                    >
                                        <Box
                                            component="img"
                                            src={keapWhite}
                                            alt="keap"
                                            sx={{ maxHeight: "30px", objectFit: "contain" }}
                                        />
                                        <Box
                                            component="img"
                                            src={dolbyWhite}
                                            alt="dolby"
                                            sx={{ maxHeight: "30px", objectFit: "contain" }}
                                        />
                                        <Box
                                            component="img"
                                            src={foundrWhite}
                                            alt="foundr"
                                            sx={{ maxHeight: "30px", objectFit: "contain" }}
                                        />
                                        <Box
                                            component="img"
                                            src={clientPointWhite}
                                            alt="clientPoint"
                                            sx={{ maxHeight: "30px", objectFit: "contain" }}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}

            {/* Step 2 - Payment Details */}
            {currentStep === 'payment' && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: {
                            xs: "calc(100vh - 120px)",
                            sm: "calc(100vh - 100px)",
                            md: "calc(100vh - 80px)",
                        },
                        p: { xs: 1, sm: 2 },
                        pt: { xs: 1, sm: 2, md: 3 },
                    }}
                >
                    {/* Main container with border - responsive sizing */}
                    <Box
                        sx={{
                            width: { xs: "100%", sm: "90%", md: "1200px", lg: "1400px" },
                            maxWidth: { xs: "600px", md: "none" },
                            height: { xs: "auto" },
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "18px",
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            bgcolor: "#ffffff",
                            boxShadow: "0 4px 32px 0 rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        {/* Left side - Promotional Section */}
                        <Box
                            sx={{
                                width: "50%",
                                bgcolor: "#f8fafc",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: { xs: "none", md: "flex" },
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: { xs: "18px", md: "18px 0 0 18px" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            {/* Back Button */}
                            <Button
                                variant="text"
                                startIcon={<ChevronLeft />}
                                onClick={() => navigate('/signup')}
                                sx={{
                                    position: 'absolute',
                                    top: { xs: 8, md: 24 },
                                    left: { xs: 16, md: 24 },
                                    color: theme.palette.text.secondary + ' !important',
                                    textTransform: 'none',
                                    boxShadow: 'none !important',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                        boxShadow: 'none !important'
                                    }
                                }}
                            >
                                Back
                            </Button>
                            <Box sx={{ textAlign: 'left' }}
                                margin="auto">
                                {/* How it works title */}
                                <Typography
                                    variant="h4"
                                    sx={{
                                        color: '#1f2937',
                                        fontSize: { xs: '20px', sm: '24px', md: '28px' },
                                        fontWeight: 700,
                                        mb: '44px',
                                        textAlign: 'center'
                                    }}
                                >
                                    How it works
                                </Typography>

                                {/* Today section */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: { xs: "24px", md: "32px", lg: "34px" } }} position="relative">
                                    <Box mr={1.5} sx={{ position: 'relative' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
                                            <path d="M0 18.293C0 8.62799 7.83502 0.792969 17.5 0.792969C27.165 0.792969 35 8.62799 35 18.293C35 27.958 27.165 35.793 17.5 35.793C7.83502 35.793 0 27.958 0 18.293Z" fill="#7F8FFC" />
                                            <path d="M0 18.293C0 8.62799 7.83502 0.792969 17.5 0.792969C27.165 0.792969 35 8.62799 35 18.293C35 27.958 27.165 35.793 17.5 35.793C7.83502 35.793 0 27.958 0 18.293Z" fill="white" fill-opacity="0.81" />
                                            <path d="M8.44939 15.5846C9.05203 15.6581 9.68066 15.6163 10.287 15.6102C10.9037 15.604 11.5204 15.5984 12.1371 15.5917C13.379 15.5781 14.6209 15.5725 15.8627 15.5575C18.3249 15.5278 20.7871 15.5185 23.2488 15.4618C23.9465 15.4457 24.6444 15.4386 25.3421 15.4233C26.0398 15.4081 26.7739 15.4488 27.4618 15.3268C27.683 15.2876 27.8206 15.0303 27.7897 14.8246C27.7535 14.5843 27.5732 14.4531 27.3401 14.4277C27.0489 14.396 26.7554 14.4205 26.463 14.4295C26.1428 14.4394 25.8227 14.4485 25.5025 14.4569C24.8859 14.4732 24.2691 14.487 23.6524 14.4989C22.4109 14.5229 21.1684 14.5206 19.9267 14.5322C17.4645 14.5552 15.0025 14.5561 12.5407 14.6118C11.8427 14.6275 11.145 14.6466 10.4474 14.6732C9.75247 14.6997 9.03106 14.694 8.34651 14.8247C8.15985 14.8603 8.04296 15.0733 8.0694 15.2492C8.10026 15.4541 8.25243 15.5606 8.44939 15.5846Z" fill="#1A1818" />
                                            <path d="M11.5843 9.91308C11.0492 9.87775 10.5342 9.84377 9.99702 9.87192C9.52882 9.89648 9.04687 9.97429 8.66462 10.2654C8.25381 10.5783 8.08567 11.0498 8.03183 11.5478C7.97462 12.0768 8.01165 12.6221 8.01336 13.1534C8.02091 15.4969 8.05906 17.8402 8.082 20.1837C8.09338 21.3485 8.10677 22.5133 8.11795 23.6781C8.12887 24.8162 8.10861 25.9607 8.15686 27.0978C8.17812 27.5987 8.27675 28.1082 8.62855 28.4878C8.96384 28.8496 9.44342 28.9885 9.91711 29.0475C10.3996 29.1075 10.8923 29.0968 11.3777 29.1073C11.8981 29.1185 12.4187 29.1269 12.9393 29.1326C14.1024 29.1455 15.2657 29.1487 16.4289 29.1426C17.6866 29.1359 18.9537 29.1718 20.2097 29.1112C20.7979 29.0828 20.8 28.2214 20.2097 28.1957C19.1551 28.1497 18.092 28.1918 17.0363 28.1961C16.0397 28.2002 15.0431 28.2064 14.0465 28.2055C13.0692 28.2045 12.0917 28.1977 11.1146 28.1763C10.6911 28.167 10.2437 28.1913 9.82766 28.1023C9.49792 28.0318 9.23324 27.8932 9.13549 27.5488C9.01213 27.1143 9.05971 26.6207 9.05221 26.1741C9.04286 25.6194 9.03548 25.0647 9.02606 24.5101C9.00721 23.4008 8.98815 22.2915 8.97009 21.1821C8.93415 18.9775 8.91146 16.7721 8.865 14.5678C8.85187 13.9437 8.83761 13.3198 8.82284 12.6958C8.81158 12.2194 8.71446 11.6286 8.90445 11.1744C9.06538 10.7897 9.50005 10.6905 9.87687 10.6658C10.1451 10.6482 10.4145 10.6541 10.6825 10.6355C10.9853 10.6146 11.2831 10.5611 11.5844 10.5256C11.9699 10.4802 11.9858 9.9396 11.5843 9.91308Z" fill="#1A1818" />
                                            <path d="M11.8484 10.4872C12.0706 9.99499 11.9814 9.41958 12.0625 8.89893C12.0672 8.86857 12.1123 8.80668 12.071 8.83308C12.0218 8.86444 12.1028 8.84663 12.1148 8.84872C12.23 8.86882 12.3678 8.85118 12.4852 8.85331C12.6276 8.85589 12.7699 8.85848 12.9123 8.86106C12.977 8.86223 13.0417 8.86319 13.1064 8.86457C13.1323 8.86502 13.1582 8.86552 13.1841 8.86598C13.2594 8.87049 13.2576 8.86857 13.1788 8.86014C13.1488 8.80852 13.1186 8.75689 13.0886 8.7053C13.135 8.83396 13.1083 9.03046 13.1115 9.17154C13.1154 9.34289 13.1197 9.51421 13.1236 9.68552C13.1314 10.031 13.1428 10.3766 13.1463 10.7221C13.1498 11.0529 13.145 11.3845 13.1221 11.7146C13.1063 11.943 13.0958 12.0729 12.8694 12.1293C12.6654 12.1802 12.4389 12.1634 12.2324 12.1341C12.1685 12.125 12.0001 12.1172 11.9652 12.0574C11.9348 12.0054 11.9761 11.7917 11.9802 11.7184C12.0215 10.9702 12.0886 10.2199 12.0582 9.47246C12.0399 9.02333 11.405 9.03329 11.3675 9.47246C11.3225 9.99941 11.3326 10.523 11.3381 11.0529C11.3408 11.3025 11.3448 11.552 11.346 11.8016C11.347 12.0371 11.3237 12.2698 11.4869 12.4626C11.7156 12.7327 12.1211 12.7577 12.4512 12.7706C12.7671 12.783 13.1427 12.7817 13.4133 12.5956C13.794 12.3338 13.7971 11.8223 13.8254 11.4075C13.8583 10.9256 13.8675 10.44 13.8514 9.95734C13.8436 9.72205 13.8339 9.48685 13.8249 9.25161C13.8159 9.01599 13.8442 8.74338 13.7655 8.51877C13.5972 8.03902 12.9176 8.16638 12.5241 8.16417C12.2849 8.16284 12.0209 8.12969 11.7931 8.21643C11.5412 8.31234 11.4169 8.5367 11.3868 8.79392C11.3562 9.05444 11.3611 9.32713 11.3692 9.58906C11.3779 9.86601 11.3582 10.1721 11.4539 10.4357C11.5101 10.5905 11.765 10.6719 11.8484 10.4872Z" fill="#1A1818" />
                                            <path d="M22.2117 10.4448C22.294 10.0452 22.3151 9.65273 22.3244 9.24609C22.3285 9.06714 22.2996 8.85037 22.3378 8.67589C22.3279 8.72084 22.2834 8.68473 22.3659 8.69415C22.4503 8.70379 22.5421 8.69157 22.6271 8.69207C22.8352 8.69324 23.0433 8.70658 23.2513 8.7153C23.3439 8.71918 23.5698 8.68465 23.6443 8.74178C23.641 8.73932 23.6398 8.87181 23.6394 8.9294C23.639 9.02127 23.6387 9.11314 23.6384 9.20501C23.6356 10.1469 23.6724 11.0981 23.6206 12.0388C23.5915 12.5653 24.4058 12.5618 24.4383 12.0388C24.4932 11.1543 24.4504 10.2629 24.4228 9.37828C24.4079 8.90071 24.4865 8.25816 23.9309 8.0619C23.6246 7.95373 23.256 8.01749 22.9391 8.03046C22.6349 8.04289 22.2415 7.96962 21.9656 8.12642C21.5999 8.3341 21.6733 8.81342 21.6792 9.16468C21.6864 9.5991 21.7008 10.0175 21.786 10.4448C21.8281 10.6561 22.1685 10.6547 22.2117 10.4448Z" fill="#1A1818" />
                                            <path d="M23.8349 9.64194C23.7782 10.0545 23.6976 10.4653 23.6851 10.882C23.6726 11.2995 23.6856 11.7165 23.6581 12.1338C23.78 12.0119 23.902 11.8899 24.0239 11.7681C23.7239 11.7857 23.427 11.8297 23.1261 11.8379C22.8747 11.8447 22.5498 11.8867 22.3055 11.8149C22.3545 11.8293 22.3148 11.922 22.3379 11.8046C22.3435 11.776 22.3372 11.7357 22.3376 11.7067C22.3387 11.6306 22.3377 11.551 22.348 11.4755C22.3729 11.2921 22.3741 11.0776 22.3747 10.8775C22.3759 10.4263 22.3792 9.97497 22.3753 9.52379C22.3735 9.32383 22.3719 9.12387 22.371 8.9239C22.3702 8.741 22.3845 8.55334 22.336 8.37535C22.2481 8.0532 21.7866 8.06388 21.6935 8.37535C21.6369 8.56464 21.6544 8.77373 21.6534 8.96957C21.6522 9.20873 21.6505 9.44794 21.6518 9.68706C21.6546 10.1849 21.6628 10.6828 21.6663 11.1807C21.6676 11.3774 21.7007 11.544 21.6989 11.7407C21.696 12.0434 21.7734 12.3109 22.0832 12.4254C22.366 12.5298 22.7178 12.5101 23.0155 12.5128C23.35 12.5158 23.6904 12.5275 24.0238 12.4994C24.2272 12.4823 24.381 12.3455 24.3895 12.1337C24.406 11.7293 24.4024 11.3211 24.3845 10.9168C24.3664 10.5072 24.2762 10.1099 24.2636 9.69994C24.2564 9.46662 23.8697 9.38814 23.8349 9.64194Z" fill="#1A1818" />
                                            <path d="M13.4549 10.5928C13.8282 10.705 14.2661 10.6864 14.6542 10.6947C14.9987 10.7021 15.3438 10.6984 15.6884 10.6985C16.3673 10.6988 17.0462 10.6846 17.7251 10.6862C19.1418 10.6895 20.558 10.6513 21.9741 10.611C22.4905 10.5963 22.4908 9.78572 21.9741 9.80791C20.5583 9.86867 19.1419 9.91158 17.7251 9.93727C17.0585 9.94936 16.3907 9.93347 15.7242 9.92105C15.3675 9.91442 15.0108 9.90103 14.6542 9.89678C14.2635 9.89215 13.8355 9.85878 13.4549 9.95503C13.1307 10.037 13.15 10.5011 13.4549 10.5928Z" fill="#1A1818" />
                                            <path d="M13.9772 21.5322C14.0918 21.4004 14.2233 21.2618 14.3962 21.2377C14.6218 21.2063 14.8193 21.3787 14.9815 21.5386C15.3729 21.9245 15.7644 22.3104 16.1558 22.6963C16.3121 22.8503 16.5116 23.0172 16.7242 22.963C16.8582 22.9289 16.9539 22.8145 17.0402 22.7065C18.4469 20.9444 19.8535 19.1823 21.2602 17.4203C21.7588 17.7321 22.2171 18.108 22.6206 18.5357C22.7477 18.6704 22.8756 18.8246 22.8884 19.0094C22.9035 19.228 22.7546 19.4201 22.614 19.5882C20.938 21.5923 19.2619 23.5963 17.5858 25.6003C17.4219 25.7964 17.2335 26.0064 16.9801 26.0391C16.7376 26.0704 16.5097 25.9293 16.3075 25.7917C15.4018 25.1753 14.5303 24.5086 13.6983 23.7959C13.3886 23.5307 12.9017 23.2399 13.0433 22.7701C13.1783 22.3217 13.6765 21.8779 13.9772 21.5322Z" fill="#1A1818" />
                                            <path d="M16.2576 22.3816C15.8733 21.7776 15.164 21.4489 14.718 20.8941C14.5945 20.7405 14.3319 20.7677 14.2043 20.8941C13.6384 21.4549 13.0949 22.035 12.55 22.6161C12.4299 22.7442 12.3968 22.9937 12.55 23.1167C13.7256 24.0608 14.9112 24.993 16.0849 25.9395C16.3611 26.1622 16.6593 26.4998 17.0443 26.4803C17.4944 26.4575 17.8224 25.9474 18.0926 25.6416C18.7021 24.9518 19.2704 24.23 19.8326 23.5017C20.145 23.0969 20.4574 22.692 20.7776 22.2933C21.1148 21.8736 21.483 21.4811 21.8225 21.0636C22.0441 20.7911 21.6985 20.4261 21.4309 20.672C20.7944 21.2568 20.2435 21.9546 19.6898 22.6173C19.139 23.2763 18.5993 23.9448 18.0424 24.5986C17.7619 24.9278 17.4751 25.2517 17.1789 25.5669C17.1229 25.6264 17.0681 25.691 17.0054 25.7441C16.9466 25.794 16.9996 25.739 17.0235 25.75C16.9977 25.7381 16.9713 25.7187 16.9484 25.7019C16.822 25.6091 16.7049 25.4998 16.5832 25.4006C16.0263 24.9467 15.4604 24.5044 14.8917 24.0654C14.2746 23.589 13.6429 23.1235 13.0506 22.616C13.0506 22.7829 13.0506 22.9498 13.0506 23.1166C13.6138 22.5532 14.1759 21.9914 14.718 21.4077C14.5468 21.4077 14.3756 21.4077 14.2043 21.4077C14.656 21.9242 15.2871 22.278 15.792 22.7408C16.0311 22.9601 16.4457 22.6772 16.2576 22.3816Z" fill="#1A1818" />
                                            <path d="M14.3353 21.2028C14.4677 21.7016 14.8683 22.0859 15.2411 22.4213C15.6301 22.7713 16.0422 23.1002 16.4856 23.3789C16.6275 23.4681 16.8731 23.4506 16.9854 23.3144C17.7611 22.3728 18.5312 21.4264 19.3122 20.4891C20.0894 19.5565 20.8604 18.5927 21.7328 17.7467C21.5734 17.7672 21.414 17.7878 21.2547 17.8083C21.8448 18.1894 22.3936 18.6857 22.8328 19.2336C22.8328 19.0215 22.8328 18.8096 22.8328 18.5975C22.0212 19.5348 21.2302 20.4933 20.4534 21.4595C20.0817 21.9218 19.7239 22.3958 19.3658 22.8686C18.968 23.3939 18.5584 23.9124 18.1942 24.4616C17.9763 24.7902 18.4807 25.1858 18.7442 24.886C19.1794 24.391 19.5775 23.8642 19.9951 23.3542C20.3547 22.9152 20.7224 22.483 21.0834 22.0453C21.8656 21.0969 22.6766 20.1734 23.4688 19.2335C23.6354 19.0358 23.6374 18.7965 23.4688 18.5975C22.9732 18.0128 22.3457 17.4618 21.6529 17.127C21.5085 17.0572 21.2885 17.0475 21.1749 17.1887C20.4118 18.137 19.5544 19.0137 18.7545 19.9314C17.9532 20.8507 17.1733 21.7864 16.4021 22.7311C16.5687 22.7096 16.7353 22.6881 16.9019 22.6666C16.5062 22.4204 16.1285 22.1423 15.7723 21.8419C15.4102 21.5366 15.0699 21.1868 14.6524 20.959C14.4879 20.8694 14.286 21.0175 14.3353 21.2028Z" fill="#1A1818" />
                                            <path d="M27.2346 12.1156C27.2068 12.3492 27.1648 12.5808 27.1454 12.8152C27.1261 13.0477 27.1336 13.2823 27.1332 13.5155C27.1326 13.9829 27.1374 14.4503 27.1347 14.9176C27.1292 15.8677 27.1133 16.8177 27.1103 17.7679C27.1042 19.6417 27.1264 21.5154 27.1223 23.3894C27.1203 24.3379 27.1143 25.2863 27.1007 26.2347C27.0951 26.6237 27.1213 27.0326 27.0604 27.4178C27.0122 27.7229 26.8828 27.9718 26.5838 28.0902C26.3029 28.2014 25.9775 28.2084 25.6769 28.2161C25.2469 28.2271 24.8168 28.2341 24.3867 28.2398C23.5282 28.2512 22.6695 28.2499 21.8109 28.2432C20.8344 28.2357 19.858 28.2191 18.8814 28.2089C17.838 28.198 16.7828 28.1453 15.7406 28.1979C15.1513 28.2276 15.1516 29.0808 15.7406 29.1134C16.6922 29.166 17.6531 29.1374 18.6063 29.1492C19.5221 29.1606 20.4379 29.1692 21.3537 29.174C22.2386 29.1786 23.1235 29.1779 24.0083 29.1693C24.4631 29.1649 24.918 29.1587 25.3726 29.1463C25.7613 29.1356 26.1527 29.1283 26.5352 29.0497C26.9166 28.9714 27.2996 28.794 27.554 28.4912C27.8365 28.1548 27.9398 27.7433 27.9754 27.3136C28.0118 26.8744 27.9956 26.428 27.9976 25.9876C27.9997 25.493 28.0003 24.9984 27.9999 24.5037C27.9983 22.5623 27.9925 20.6185 27.9629 18.6774C27.9463 17.5892 27.9282 16.5011 27.9149 15.4129C27.9081 14.8627 27.9124 14.3128 27.9181 13.7627C27.9208 13.5021 27.9312 13.2405 27.9276 12.9799C27.9236 12.6903 27.8737 12.4035 27.847 12.1155C27.8103 11.7182 27.2809 11.726 27.2346 12.1156Z" fill="#1A1818" />
                                            <path d="M23.9617 10.4957C24.2977 10.5949 24.6698 10.5645 25.0182 10.5692C25.3397 10.5734 25.669 10.5624 25.9889 10.5984C26.4873 10.6546 26.8156 10.9074 26.9465 11.3907C27.0934 11.9327 27.0619 12.5257 27.0719 13.0821C27.0777 13.4013 27.0821 13.7207 27.088 14.0399C27.0948 14.4089 27.088 14.7781 27.1959 15.1328C27.2906 15.4441 27.7626 15.4646 27.8478 15.1328C27.9459 14.7508 27.9268 14.3588 27.9298 13.9661C27.9325 13.5958 27.9361 13.2254 27.9353 12.855C27.9339 12.22 27.9675 11.5309 27.7412 10.9258C27.4795 10.226 26.922 9.84771 26.1889 9.76727C25.8399 9.72899 25.4858 9.74066 25.1353 9.74388C24.7505 9.74742 24.3321 9.71026 23.9617 9.82023C23.6294 9.91894 23.6282 10.3973 23.9617 10.4957Z" fill="#1A1818" />
                                        </svg>
                                    </Box>
                                    {/* Connector line */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            left: "16px",
                                            top: '39px',
                                            width: '2px',
                                            height: { xs: '32px', md: '100%' },
                                            background: 'repeating-linear-gradient(to bottom, #808185 0px, #000000 4px, transparent 4px, transparent 8px)',
                                            transform: 'translateX(-50%)',
                                            zIndex: 1
                                        }}
                                    />
                                    <Box>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: '18px',
                                                fontWeight: 700,
                                                mb: 0.5,
                                            }}
                                        >
                                            Today
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: '#7C7D7E',
                                                fontSize: { xs: '16px', xl: '18px' },
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            All features are now available. Experience the full power.
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Day 6 section */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: { xs: "24px", md: "32px", lg: "34px" } }} position='relative'>
                                    <Box mr={1.5}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                            <path d="M0 16.9297C0 8.09313 7.16344 0.929688 16 0.929688C24.8366 0.929688 32 8.09313 32 16.9297C32 25.7662 24.8366 32.9297 16 32.9297C7.16344 32.9297 0 25.7662 0 16.9297Z" fill="#7F8FFC" />
                                            <path d="M0 16.9297C0 8.09313 7.16344 0.929688 16 0.929688C24.8366 0.929688 32 8.09313 32 16.9297C32 25.7662 24.8366 32.9297 16 32.9297C7.16344 32.9297 0 25.7662 0 16.9297Z" fill="white" fill-opacity="0.81" />
                                            <path d="M17.9083 24.9883C17.9083 26.0416 17.0544 26.8955 16.001 26.8955C14.9477 26.8955 14.0938 26.0416 14.0938 24.9883" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M14.1684 8.43727C14.1198 8.269 14.0938 8.09118 14.0938 7.90726C14.0938 6.85391 14.9477 6 16.001 6C17.0544 6 17.9083 6.85391 17.9083 7.90726C17.9083 8.03893 17.8949 8.16749 17.8695 8.29165" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22.1904 16.7839C22.7709 11.4865 19.9976 8.34766 16.0261 8.34766C16.0169 8.34766 16.0079 8.348 15.9987 8.348C15.9896 8.34795 15.9806 8.34766 15.9714 8.34766C11.9999 8.34766 9.22657 11.4865 9.80704 16.7839C10.0864 19.3332 9.42145 21.367 8.71414 22.7368C8.24782 23.6399 8.89917 24.7161 9.91554 24.7161H22.0819C23.0983 24.7161 23.7496 23.6399 23.2833 22.7368C22.576 21.367 21.911 19.3332 22.1904 16.7839Z" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.23633 21.543H18.7934" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22.3008 8.82812C22.737 8.82812 23.1732 8.99451 23.506 9.32733C23.8388 9.66015 24.0052 10.0964 24.0052 10.5325" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22.3008 6.83594C23.2472 6.83594 24.1937 7.19699 24.9158 7.91915C25.6379 8.6413 25.999 9.58773 25.999 10.5342" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.7005 8.82812C9.26429 8.82812 8.82808 8.99451 8.4953 9.32733C8.16253 9.66015 7.99609 10.0964 7.99609 10.5325" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.69825 6.83594C8.75179 6.83594 7.80532 7.19699 7.08321 7.91915C6.3611 8.6413 6 9.58773 6 10.5342" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </Box>
                                    {/* Connector line */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            left: "16px",
                                            top: '39px',
                                            width: '2px',
                                            height: { xs: '32px', md: '100%' },
                                            background: 'repeating-linear-gradient(to bottom, #808185 0px, #000000 4px, transparent 4px, transparent 8px)',
                                            transform: 'translateX(-50%)',
                                            zIndex: 1
                                        }}
                                    />
                                    <Box>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: '18px',
                                                fontWeight: 700,
                                                mb: 0.5,
                                            }}
                                        >
                                            Day 6
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: '#7C7D7E',
                                                fontSize: { xs: '16px', xl: '18px' },
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            We'll remind you 1 day before your free access ends.
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* After Day 7 section */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <Box mr={1.5}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
                                            <path d="M0 15.0664C0 6.78214 6.71573 0.0664062 15 0.0664062C23.2843 0.0664062 30 6.78214 30 15.0664C30 23.3507 23.2843 30.0664 15 30.0664C6.71573 30.0664 0 23.3507 0 15.0664Z" fill="#7F8FFC" />
                                            <path d="M0 15.0664C0 6.78214 6.71573 0.0664062 15 0.0664062C23.2843 0.0664062 30 6.78214 30 15.0664C30 23.3507 23.2843 30.0664 15 30.0664C6.71573 30.0664 0 23.3507 0 15.0664Z" fill="white" fill-opacity="0.81" />
                                            <mask id="mask0_15479_32349" mask-type="luminance" maskUnits="userSpaceOnUse" x="5" y="5" width="20" height="20">
                                                <path d="M24.9854 5.01465V24.9854H5.01465V5.01465H24.9854Z" fill="white" stroke="white" stroke-width="0.0292969" />
                                            </mask>
                                            <g mask="url(#mask0_15479_32349)">
                                                <path d="M18.8671 12.3799L13.6259 17.6211L11.1309 15.1261" stroke="#3C3737" stroke-width="1.5625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                <mask id="mask1_15479_32349" mask-type="luminance" maskUnits="userSpaceOnUse" x="5" y="5" width="20" height="20">
                                                    <path d="M24.9805 24.9805V5.01953H5.01953V24.9805H24.9805Z" fill="white" stroke="white" stroke-width="0.0390625" />
                                                </mask>
                                                <g mask="url(#mask1_15479_32349)">
                                                    <path d="M24.2148 15C24.2148 20.0914 20.0875 24.2188 14.9961 24.2188C9.90473 24.2188 5.77734 20.0914 5.77734 15C5.77734 9.90864 9.90473 5.78125 14.9961 5.78125C20.0875 5.78125 24.2148 9.90864 24.2148 15Z" stroke="#3C3737" stroke-width="1.5625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                            </g>
                                        </svg>
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: '18px',
                                                fontWeight: 700,
                                                mb: 0.5,
                                            }}
                                        >
                                            After Day 7
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: '#7C7D7E',
                                                fontSize: { xs: '16px', xl: '18px' },
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            Your subscription begins unless you cancel beforehand.
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            {/* Divider */}
                            <Box
                                sx={{
                                    width: '70%',
                                    height: '3px',
                                    background: 'linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.2) 20%, rgba(0, 0, 0, 0.2) 80%, transparent 100%)',
                                    opacity: 0.2,
                                    my: 5,
                                    mx: 'auto'
                                }}
                            />

                            {/* G2 Badges Section */}
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    pb: 4,
                                    px: 2,
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: '#000000',
                                        fontSize: { xs: '18px', md: '18px', xl: '20px' },
                                        lineHeight: 1.4,
                                        mb: 3,
                                        textAlign: 'center',
                                        maxWidth: '500px',
                                        mx: 'auto'
                                    }}
                                >
                                    Recognized by customers across the world as a leader in multiple categories on G2
                                </Typography>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexWrap: { xs: 'wrap', md: 'nowrap' },
                                        gap: { xs: 2, md: 3 },
                                        maxWidth: '100%',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <img
                                        src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png"
                                        srcSet="
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png 1x,
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-2x.png 2x,
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-3x.png 3x
                                                "
                                        alt="G2 Badges - High Performer, Users Love Us, High Performer Asia Pacific, Leader Small Business, Momentum Leader"
                                        style={{
                                            maxWidth: '500px',
                                            height: 'auto',
                                        }}
                                    />
                                </Box>
                            </Box>

                        </Box>

                        {/* Right side - Form Section */}
                        <Box
                            sx={{
                                width: { xs: "100%", md: "50%" },
                                bgcolor: "#ffffff",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: { xs: "18px", md: "0 18px 18px 0" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            <Box sx={{ textAlign: "center", mb: 2 }}>
                                <Typography
                                    color="#000000"
                                    fontSize={{ xs: "min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)", lg: "16px" }}
                                    fontWeight="600"
                                    mb="8px"
                                    textAlign="center"
                                >
                                    {planDetails?.externalName} plan
                                </Typography>
                                <Typography
                                    color="#333333"
                                    fontWeight="700"
                                    fontSize={{ xs: "min(calc(20px + 8 * (100vw - 400px) / (1920 - 400)), 28px)", lg: "28px" }}
                                    mb="8px"
                                    textAlign="center"
                                    lineHeight="1.2"
                                >
                                    7 days free with full access.
                                </Typography>
                                <Typography
                                    color="#71757D"
                                    fontSize={{ xs: "min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)", lg: "16px" }}
                                    fontWeight="600"
                                    textAlign="center"
                                >
                                    No strings attached. Cancel anytime.
                                </Typography>
                            </Box>

                            <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                                {/* plan boxes */}
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4, mt: { xs: 1, sm: 0 } }}>
                                    {/* Monthly Plan */}
                                    <Box
                                        sx={{
                                            flex: 1,
                                            bgcolor: !isYearly ? "#f8fafc" : "#ffffff",
                                            border: "2px solid",
                                            borderColor: !isYearly ? "#8b5cf6" : "#e5e7eb",
                                            borderRadius: "12px",
                                            p: { xs: "8px", sm: "10px" },
                                            cursor: "pointer",
                                            transition: "all 0.2s ease",
                                            maxWidth: "170px",
                                            width: "100%",
                                            "&:hover": {
                                                borderColor: !isYearly ? "#7c3aed" : "#d1d5db",
                                            },
                                        }}
                                        onClick={() => handleBillingPeriodChange(false)}
                                    >

                                        <Typography
                                            sx={{
                                                color: !isYearly ? "#1f2937" : "#6b7280",
                                                fontSize: "16px",
                                                fontWeight: 600,
                                                textAlign: "center",
                                                mb: 0.5,
                                            }}
                                        >
                                            {calculateDynamicPricing().monthlyPrice}/month
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#6b7280",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                textAlign: "center",
                                            }}
                                        >
                                            (Monthly billing)
                                        </Typography>
                                    </Box>

                                    {/* Yearly Plan */}
                                    <Box
                                        sx={{
                                            flex: 1,
                                            bgcolor: isYearly ? "#f8fafc" : "#ffffff",
                                            border: "2px solid",
                                            borderColor: isYearly ? "#8b5cf6" : "#e5e7eb",
                                            borderRadius: "12px",
                                            p: { xs: "8px", sm: "10px" },
                                            pt: { xs: "12px", sm: "10px" }, // Add extra top padding on mobile to accommodate badge
                                            cursor: "pointer",
                                            transition: "all 0.2s ease",
                                            position: "relative",
                                            maxWidth: "170px",
                                            width: "100%",
                                            "&:hover": {
                                                borderColor: isYearly ? "#7c3aed" : "#d1d5db",
                                            },
                                        }}
                                        onClick={() => handleBillingPeriodChange(true)}
                                    >
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: { xs: -7, sm: -8 }, // Adjust top position for mobile
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                bgcolor: "#22C55D",
                                                color: "#ffffff",
                                                fontSize: { xs: "8px", sm: "9px" }, // Smaller font on mobile
                                                fontWeight: 600,
                                                px: { xs: 0.8, sm: 1 }, // Smaller padding on mobile
                                                py: { xs: 0.2, sm: 0.25 }, // Smaller padding on mobile
                                                borderRadius: "4px",
                                                zIndex: 2, // Ensure it stays on top
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {isYearly ? `Saving ${calculateDynamicPricing().savings}` : `Save ${calculateDynamicPricing().savings}`}
                                        </Box>

                                        <Typography
                                            sx={{
                                                color: isYearly ? "#1f2937" : "#6b7280",
                                                fontSize: "16px",
                                                fontWeight: 600,
                                                textAlign: "center",
                                                mb: 0.5,
                                            }}
                                        >
                                            {calculateDynamicPricing().yearlyPrice}/month
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                                            <Typography
                                                sx={{
                                                    color: "#6b7280",
                                                    fontSize: "14px",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                (Yearly billing)
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                {!isTrial ? (
                                    <>

                                        <Box width="100%" mb="8px">
                                            <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                Card Details
                                            </Typography>
                                            <Box width="100%" sx={{
                                                position: "relative",
                                                "& .CbHosted": {
                                                    borderRadius: '3px',
                                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                                    padding: '14px 16px',
                                                    "&:hover, &--focus": {
                                                        borderColor: '#666666',
                                                    }
                                                }
                                            }}>
                                                {isChargebeeReady ? (
                                                    <CardComponent
                                                        ref={cardRef}
                                                        currency="USD"
                                                        showTestCards={true}
                                                        styles={{
                                                            border: "1px solid #666666",
                                                            base: {
                                                                padding: "14px 16px",
                                                                border: "1px solid #666666",
                                                                fontSize: '16px',
                                                                fontFamily: 'Inter, sans-serif',
                                                                color: '#333333',
                                                                '::placeholder': {
                                                                    color: '#667085',
                                                                },
                                                            },
                                                            invalid: {
                                                                color: '#ff0000',
                                                            },
                                                        }}
                                                        onChange={(status: any) => {
                                                            console.log('Card status:', status);

                                                            if (status.error) {
                                                                setCardError(status.error.message);
                                                                setIsCardValid(false);
                                                            } else if (!status.complete) {
                                                                // Clear error but indicate card is not complete
                                                                setCardError(null);
                                                                setIsCardValid(false);
                                                            } else {
                                                                // Card is complete and valid
                                                                setCardError(null);
                                                                setIsCardValid(true);
                                                            }
                                                        }}
                                                        onReady={() => {
                                                            console.log('Card component ready');
                                                            setIsCardValid(false); // Reset validity when component is ready
                                                        }}
                                                        onBlur={() => {
                                                            console.log('Card component blurred');
                                                        }}
                                                        onFocus={() => {
                                                            console.log('Card component focused');
                                                        }}
                                                    />
                                                ) : (
                                                    <Box>
                                                        <Typography>
                                                            Loading...
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                            {cardError && (
                                                <Typography color="error" fontSize="12px" mt={1}>
                                                    {cardError}
                                                </Typography>
                                            )}
                                        </Box>
                                        <Box display="flex" justifyContent="end" flexDirection="column">
                                            {!showPromoField ? (
                                                <>
                                                    {appliedPromo ? (
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px',
                                                                padding: '4px 8px',
                                                                backgroundColor: '#F0FFF4',
                                                                borderRadius: '4px',
                                                                width: 'fit-content',
                                                                marginLeft: 'auto'
                                                            }}
                                                        >
                                                            <Typography color="#1D9652" fontSize="14px">
                                                                {appliedPromo.code} applied
                                                            </Typography>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                                fill="none"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => removePromoCode()}
                                                            >
                                                                <path d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM10.7 11.5L8 8.8L5.3 11.5L4.5 10.7L7.2 8L4.5 5.3L5.3 4.5L8 7.2L10.7 4.5L11.5 5.3L8.8 8L11.5 10.7L10.7 11.5Z" fill="#1D9652" />
                                                            </svg>
                                                        </Box>
                                                    ) : (
                                                        <Typography
                                                            color="#2B2B30"
                                                            fontSize="16px"
                                                            display="flex"
                                                            justifyContent="end"
                                                            mb="8px"
                                                            sx={{
                                                                cursor: 'pointer',
                                                                '&:hover': {
                                                                    textDecoration: 'underline'
                                                                }
                                                            }}
                                                            onClick={() => setShowPromoField(true)}
                                                        >
                                                            Have a promo code?
                                                        </Typography>
                                                    )}
                                                </>
                                            ) : (
                                                <TextField
                                                    variant="outlined"
                                                    placeholder="Promo Code:"
                                                    value={promoCode}
                                                    onChange={(e) => {
                                                        setPromoCode(e.target.value);
                                                        setPromoError('');
                                                    }}
                                                    error={!!promoError}
                                                    helperText={promoError}
                                                    sx={{
                                                        width: "100%",
                                                        marginBottom: "25px",
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: '3px',
                                                            borderColor: '#C7C7C7',
                                                            background: '#ffffff',
                                                            paddingRight: '0'
                                                        },
                                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: '#333333',
                                                            border: '1px solid'
                                                        },
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: '14px 16px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px'
                                                        },
                                                        "&.MuiInputBase-input::placeholder": {
                                                            color: '#333333',
                                                            fontSize: '16px',
                                                            opacity: '0.8'
                                                        },
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            endAdornment: (
                                                                <InputAdornment
                                                                    position="end"
                                                                    sx={{
                                                                        ".MuiTypography-root": {
                                                                            color: "#333333",
                                                                            fontWeight: "500",
                                                                            fontSize: "16px",
                                                                        },
                                                                        paddingRight: "10px",
                                                                    }}
                                                                >
                                                                    <Box display="flex" justifyContent="center" alignItems="center">
                                                                        <Box
                                                                            sx={{
                                                                                background: theme.palette.primary.main,
                                                                                borderRadius: '4px',
                                                                                padding: '4px 10px',
                                                                                marginRight: '4px',
                                                                                minWidth: '57px',
                                                                                fontSize: '14px',
                                                                                fontWeight: '500',
                                                                                color: '#fff',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={validateCoupon}
                                                                        >
                                                                            Apply
                                                                        </Box>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="17"
                                                                            height="16"
                                                                            viewBox="0 0 17 16"
                                                                            fill="none"
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => {
                                                                                setShowPromoField(false);
                                                                                setPromoError('');
                                                                            }}
                                                                        >
                                                                            <path d="M8.07324 1C4.17324 1 1.07324 4.1 1.07324 8C1.07324 11.9 4.17324 15 8.07324 15C11.9732 15 15.0732 11.9 15.0732 8C15.0732 4.1 11.9732 1 8.07324 1ZM10.7732 11.5L8.07324 8.8L5.37324 11.5L4.57324 10.7L7.27324 8L4.57324 5.3L5.37324 4.5L8.07324 7.2L10.7732 4.5L11.5732 5.3L8.87324 8L11.5732 10.7L10.7732 11.5Z" fill="#A3A3A3" />
                                                                        </svg>
                                                                    </Box>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </>
                                ) : null}
                                <Box sx={{
                                    flex: 1, position: 'relative', '@media (max-width: 768px)': {
                                        width: '100%',
                                    }
                                }} display="flex" flexDirection="column" justifyContent="space-between">
                                    <Box>
                                        <Box display="flex" gap={{ xs: "13px", sm: "119px" }} justifyContent="center" alignItems="center" mt={{ xs: "20px", md: '42px' }}>
                                            <Button
                                                variant="contained"
                                                onClick={handleGetStarted}
                                                className="x-large-btn"
                                                disabled={isLoading || (!isTrial && !isCardValid)}
                                                disableElevation
                                                fullWidth
                                                sx={{
                                                    textTransform: "capitalize",
                                                    px: "44px",
                                                    height: "47px!important",
                                                    fontSize: "18px",
                                                    bgcolor: "#0382F7 !important",
                                                    "&:hover": { bgcolor: "#006dd1 !important" },
                                                    "&.Mui-disabled": {
                                                        bgcolor: "#cccccc !important",
                                                        color: "#666666 !important"
                                                    }
                                                }}
                                            >
                                                {isLoading ? (
                                                    <CircularProgress size={24} sx={{ color: 'white' }} />
                                                ) : !isTrial && !isCardValid ? (
                                                    'Please complete card details'
                                                ) : (
                                                    'Start 7-day free trial'
                                                )}
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            mt: 2,
                                            mb: 2
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: '#374151',
                                                fontSize: '14px',
                                                fontWeight: 400,
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            100% Free Trial • Cancel Anytime • No Hidden Fees
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: '#374151',
                                                fontSize: '10px',
                                                fontWeight: 400,
                                                lineHeight: 1.5,
                                                mt: 2,
                                            }}
                                        >
                                            By starting your trial, you agree to our <a href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Terms of Service</a> and <a href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Privacy Policy</a>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
}
export default SSOSignup
